import _Checkbox from './Checkbox';

import './style/index.js';

export type { CheckBoxProps } from './Checkbox';
export * from './type';

export const Checkbox = _Checkbox;
// export default Checkbox;
